/**
 * Due modi per chiamare il metodo
 * 
 * 1. formatScadenza('08/2022', '') --> 202208
 * 2. formatScadenza('202208', '') --> 202208
 * 3. formatScadenza('2022', '8') --> 202208
 *  * 
 * @param {*} annomese Es. 08/2022 oppure 2022
 * @param {*} mese Es. '8'
 * @returns aaaamm Es. 202208
 */
export function formatScadenza(scadenza) {
    if (isFormattatoMM_SLASH_AAAA(scadenza)) {
        return convertMM_SLASH_AAAAToAAAAMM(scadenza);
    }

    if (isFormattatoAAAA_dash_MM_dash_GG(scadenza)) {
        return convertAAAA_dash_MM_dash_GGToAAAAMM(scadenza);
    }

    if (isFormattatoAAAAMM(scadenza.toString())) {
        return scadenza.toString();
    }

    return scadenza.toString();
}

export function formatDataPagamento(scadenza) {
    console.log("formatDataPagamento", scadenza)
    if (isFormattatoDD_slash_MM_SLASH_AAAA(scadenza)) {
        return convertDD_slash_MM_slash_AAAA_to_AAAA_dash_MM_dash_DD(scadenza);
    }

    if (isFormattatoAAAA_dash_MM_dash_GG(scadenza)) {
        return scadenza.toString();
    }
}

export function convertAAAA_dash_MM_dash_GGToAAAAMM(annomesegiorno) {
    //console.log('convertAAAA_dash_MM_dash_GGToAAAAMM', annomesegiorno)
    const arrayScadenza = annomesegiorno.split("-");
    if (arrayScadenza[0].length === 2) {
        const res = arrayScadenza[1].toString() + arrayScadenza[0].toString();
        //console.log('convertAAAA_dash_MM_dash_GGToAAAAMM res', res)
        return res;
    } else {
        const res = arrayScadenza[0].toString() + arrayScadenza[1].toString();
        //console.log('convertAAAA_dash_MM_dash_GGToAAAAMM res', res)
        return res;
    }
}

export function convertGG_slash_MM_slash_AAToAAAAMMGG(annomesegiorno) {
    //console.log('convertGG_slash_MM_slash_AAToAAAAMMGG', annomesegiorno)
    const arrayScadenza = annomesegiorno.split("/");
    if (arrayScadenza.length >= 3) {
        const res = parseInt(arrayScadenza[2].toString() + arrayScadenza[1].toString().padStart('0', 2) + arrayScadenza[0].toString().padStart('0', 2));
        //console.log('convertGG_slash_MM_slash_AAToAAAAMMGG res', res)
        return res;
    } else {
        return '';
    }
}

function isFormattatoAAAAMM(str) {
    console.log('isFormattatoAAAAMM')
    return (str.length === 6 && isNormalInteger(str) && Number(str) > 200101);
}

function isFormattatoMM_SLASH_AAAA(str) {
    console.log('isFormattatoMM_SLASH_AAAA')
    return str.toString().includes("/");
}

function isFormattatoDD_slash_MM_SLASH_AAAA(str) {
    console.log('isFormattatoDD_slash_MM_SLASH_AAAA')
    const scad = str.toString().split('/');
    console.log('scad', scad)
    return scad.length == 3;
}

function isFormattatoAAAA_dash_MM_dash_GG(str) {
    console.log('isFormattatoAAAA_dash_MM_dash_GG')
    return str.toString().includes("-"); //TODO: TWICE
}

function isFormattatoAAAA_dash_MM(str) {
    console.log('isFormattatoAAAA_dash_MM')
    return str.toString().includes("-"); //TODO: ONCE
}

function isNormalInteger(str) {
    var n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
}

function convertMM_SLASH_AAAAToAAAAMM(str) {
    // Es. 08/2022 -> 202208
    // Funziona anche con 31/08/2022 -> 202208
    const scad = str.toString().split('/');
    return scad[scad.length - 1].toString() + scad[scad.length - 2].toString();
}

function convertDD_slash_MM_slash_AAAA_to_AAAA_dash_MM_dash_DD(str) {
    // Es. 13/08/2022 -> 2022-08-13
    const scad = str.toString().split('/');
    if (scad.length > 2) {
        return scad[scad.length - 1].toString() + "-" + scad[scad.length - 2].toString().padStart('0', 2) + "-" + scad[scad.length - 3].toString().padStart('0', 2);
    } else {
        return "ERRORE_CONVERSIONE"
    }
}

export function getMeseFromNumber(index) {
    if (isNormalInteger(index) && index <= 12) {
        const months = ['NONE', 'GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE'];
        return months[index];
    }
    return "";
}